import React, { useEffect, useState } from 'react'
import { Row, Col } from 'reactstrap'
import { Home } from 'react-feather'
import {
  ASSET_TYPE,
  CDU_TYPE,
  AIR_TYPE,
  REFRIG_TYPE,
  REFRIG_CDU_TYPE,
  ResponseStatus, METER_TYPE
} from '@common/constants'
import moment from 'moment-timezone'
import Breadcrumbs from '@components/@vuexy/breadCrumbs/BreadCrumb'
import Spinner from '@components/@vuexy/spinner/Loading-spinner'
import { NavLink } from 'react-router-dom'
import { convertToDatetimeUTC } from '@common/utils'

import * as ShopApi from '@apis/shop'
import * as AssetApi from '@apis/asset'
import * as IotApi from '@apis/iotData'

import EquipmentInfoCard from '@screens/EquipmentDetail/components/EquipmentInfoCard'
import EquipmentTempCard from '@screens/EquipmentDetail/components/EquipmentTempCard'
import EquipmentScoreCard from '@screens/EquipmentDetail/components/EquipmentScoreCard'
import EquipmentDetailGraph from '@screens/EquipmentDetail/components/EquipmentDetailGraph'

import '@assets/scss/pages/equipment-detail-graph.scss'

export default (props) => {
    const [shop, setShop] = useState({})
    const [equipment, setEquipment] = useState({})
    const [equipments, setEquipments] = useState([])
    const [assetType, setAssetType] = useState({})
    const [parametersArray, setParametersArray] = useState([])
    const [parametersDataByGroup, setParametersDataByGroup] = useState([])
    const [typeCatagoryName, setTypeCatagoryName] = useState('')
    const [iotData, setIotData] = useState({})
    const [historicalData, setHistoricalData] = useState({})
    const [graphPeriod, setGraphPeriod] = useState(4)
    const [isLoading, setLoading] = useState(true)
    const [relateAsset, setRelateAsset] = useState([])
    const [isCdu, setIsCdu] = useState(false)
    const [cduId, setCduId] = useState(null)
    const [isMeter, setIsMeter] = useState(false)
    const [meterId, setMeterId] = useState(null)

    const getShopData = async () => {
        setLoading(true)
        const [shop, equipment] = await Promise.all([
            ShopApi.getById(props.match.params.id),
            AssetApi.getById(props.match.params.assetId)
        ])
        setShop(shop.data)
        setEquipment(equipment.data[0])
        setParametersArray(equipment.data[0].parameters)
        setParametersDataByGroup(equipment.data[0].parametersDetailByGroup)
        setAssetType(getAssetType(equipment.data[0]))
        setTypeCatagoryName(equipment.data[0].typeCatagoryName)

        await getLatestData(equipment.data[0].ukey, equipment.data[0].typeCatagoryName)
        await getHistoricalData(equipment.data[0].ukey, equipment.data[0].typeCatagoryName)

        if (equipment.data[0].assetTypeCatagoryId === 3) { // CDU
            setIsCdu(true)
            setCduId(props.match.params.assetId)
            const res = await AssetApi.getAssetOfCdu(props.match.params.id, props.match.params.assetId)
            if (res.status === ResponseStatus.SUCCESS && res.data) {
                const data = res.data.map(item => {
                    item.AssetModel = {
                        assetType: item.assetType,
                        imageFilePath: item.imageFilePath,
                    }
                    return item
                })
                setRelateAsset(data)
            }
        } else if (equipment.data[0].assetTypeCatagoryId === 1) { // REFRIG
            if (equipment.data[0]?.cduAsset) {
                setRelateAsset([equipment.data[0]?.cduAsset])
            }
        } else if (equipment.data[0].assetTypeCatagoryId === 6) { // METER
          setIsMeter(true)
          setMeterId(props.match.params.assetId)
          const res = await AssetApi.getAssetOfMeter(props.match.params.id, props.match.params.assetId)
          if (res.status === ResponseStatus.SUCCESS && res.data) {
            const data = res.data.map(item => {
              item.AssetModel = {
                assetType: item.assetType,
                imageFilePath: item.imageFilePath,
              }
              return item
            })
            setRelateAsset(data)
          }
      }
      setLoading(false)

        const equipments = await ShopApi.getAssetByShop(props.match.params.id)
        setEquipments(equipments.data)
    }

    const getAssetType = (equipment) => {
        return (equipment && ASSET_TYPE[equipment.assetType] || ASSET_TYPE['Undefined'])
    }

    const getLatestData = async (ukey, typeCatagoryName) => {
        const fetchFn = getFetchLatestFn(typeCatagoryName)
        if (fetchFn) {
            const iotData = await fetchFn(ukey)
            setIotData(iotData.data)
        }
    }

    const getHistoricalData = async (ukey, typeCatagoryName, periodHours, periodDate) => {
        const fetchFn = getFetchHistoricalFn(typeCatagoryName)
        if (fetchFn) {
            const period = periodHours || graphPeriod

            const periodDateFrom = periodHours === 24 ? moment(periodDate).startOf('day') : moment().subtract(period, 'hours')
            const periodDateTo = periodHours === 24 ? moment(periodDate).endOf('day') : null

            const fromDateUTC = convertToDatetimeUTC(periodDateFrom)
            const toDateUTC = periodDateTo ? convertToDatetimeUTC(periodDateTo) : null

            const iotDatas = await fetchFn(ukey, fromDateUTC, toDateUTC)
            setHistoricalData(iotDatas.data)
            setGraphPeriod(period)
        }

    }

    const getFetchLatestFn = (typeCatagoryName) => {
        switch (typeCatagoryName) {
            case AIR_TYPE:
                return IotApi.getLatestXWebAirData
            case CDU_TYPE:
                return IotApi.getLatestXWebCduData
            case REFRIG_TYPE:
                return IotApi.getLatestXWebData
            case REFRIG_CDU_TYPE:
                return IotApi.getLatestXWebData
            case METER_TYPE:
                return IotApi.getLatestXWebMeterData
            default:
                return null
        }
    }

    const getFetchHistoricalFn = (typeCatagoryName) => {
        switch (typeCatagoryName) {
            case AIR_TYPE:
                return IotApi.getHistoricalXWebAirData
            case CDU_TYPE:
                return IotApi.getHistoricalXWebCduData
            case REFRIG_TYPE:
                return IotApi.getHistoricalXWebData
            case REFRIG_CDU_TYPE:
                return IotApi.getHistoricalXWebData
            case METER_TYPE:
                return IotApi.getHistoricalXwebMeterData
            default:
                return null
        }
    }

    const getShopName = (shop) => {
        return shop.ShopBrand.name + ' ' + shop.branchNo + ' ' + shop.detail
    }


    useEffect(() => {
        getShopData()
    }, [props.match.params.assetId])


    useEffect(() => {
        const getIotDataInterval = setInterval(async () => {
            getLatestData(equipment.ukey, equipment.typeCatagoryName)
        }, 1000 * 60)

        return () => clearInterval(getIotDataInterval)
    }, [equipment])

    if (isLoading) return <Spinner />

    return (
        <div>
            <Breadcrumbs
                breadCrumbTitle='Shop'
                breadCrumbParent={
                    <Home className='align-top' size={20} />
                }
                breadCrumbParent2={
                    <NavLink to={'/shop-asset/' + shop.id}>
                        {getShopName(shop)}
                    </NavLink>
                }
                breadCrumbActive={equipment.serial}
                breadCrumbActiveList={equipments}
            />
            <Row>
                <EquipmentInfoCard shop={shop} equipment={equipment} iotData={iotData} />
                <EquipmentTempCard shop={shop} cduId={cduId} meterId={meterId} equipments={relateAsset} iotData={iotData} showUnlinkModal={isCdu || isMeter} equipment={equipment}/>
                <EquipmentScoreCard shop={shop} equipment={equipment} iotData={iotData} />
            </Row>
            <Row>
                <Col lg='12'>
                    <EquipmentDetailGraph
                        shop={shop}
                        equipment={equipment}
                        iotData={iotData}
                        getHistoricalData={getHistoricalData}
                        assetType={assetType}
                        historicalData={historicalData.historical}
                        parametersArray={parametersArray}
                        parametersDataByGroup={parametersDataByGroup}
                        averageData={historicalData.average}
                        graphPeriod={graphPeriod}
                        typeCatagoryName={typeCatagoryName}
                    />
                </Col>
            </Row>
        </div>
    )
}
